// extracted by mini-css-extract-plugin
export default {"Container":"ViewContact_Container__ENLSl","Icon":"ViewContact_Icon__UxCTN"};